import React from 'react';

const Hero = ({ scrollToSection }) => {
  return (
    <section className="hero" id="hero">
      <div className="container">
        <div className="hero-content">
          <h1>Open Recruitment HOST MOMOLIVE</h1>
          <p>Bergabunglah dengan agensi kami dan raih kesempatan untuk menjadi host terbaik dengan penghasilan menarik!</p>
          <button className="cta-button" onClick={() => scrollToSection('contact')}>
            Daftar Sekarang
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
